import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { ALL_ITEMS } from '@/config/common.config';
import GetPaginatedFilteredVariableContractLinesQuery from
  '@/graphql/contracts/getPaginatedFilteredVariableContractLines.query.gql';
import { GetPaginatedFilteredVariableContractLines, GetPaginatedFilteredVariableContractLinesVariables } from
  '@/graphql/contracts/_generated_/getPaginatedFilteredVariableContractLines.query';
import GetBCContractLinesQuery from '@/graphql/contracts/getPaginatedFilteredBCContractLines.query.gql';
import { GetPaginatedFilteredBCContractLines, GetPaginatedFilteredBCContractLinesVariables }
  from '@/graphql/contracts/_generated_/getPaginatedFilteredBCContractLines.query';

export default function useGetContractLinesFromCache(contractId: UUID) {
  const cachedVariableContractLines = apolloClientContracts.readQuery<GetPaginatedFilteredVariableContractLines,
  GetPaginatedFilteredVariableContractLinesVariables>({
    query: GetPaginatedFilteredVariableContractLinesQuery,
    variables: {
      filter: { headerPrimaryKey: { eq: contractId } },
      first: ALL_ITEMS
    }
  });

  const cachedBCContractLines = apolloClientContracts.readQuery<
  GetPaginatedFilteredBCContractLines, GetPaginatedFilteredBCContractLinesVariables>({
    query: GetBCContractLinesQuery,
    variables: {
      filter: {
        contractId: { eq: contractId }
      },
      first: ALL_ITEMS
    }
  });

  const isBCContractHasNecessaryContractLines = cachedBCContractLines &&
    cachedBCContractLines.paginatedFilteredContractLinesByBillingCycles?.items?.some(
      (cl) => cl?.billingType === 'Subscription' && (cl?.status === 'Active' || cl?.status === 'ActiveDNR'));

  const contractHasActiveSubscriptionLines = isBCContractHasNecessaryContractLines;

  return {
    cachedVariableContractLines,
    cachedBCContractLines,
    contractHasActiveSubscriptionLines
  } as const;
}
